let url = "https://api.skyshipbd.com/admin";
// let url = "http://192.168.0.103:3080/admin";
export default url;
